module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePage_Euro.97601ae6.webp";